module.exports = __webpack_public_path__ + "static/media/welder_nation.9339168b.png";